module.exports = __webpack_public_path__ + "img/nav-arrow.82276480.svg";